import _ from "lodash";
const parserPadrao = {
    mach: (laudo) => false,
    parser: (laudo) => "",
};

const parserPerdas = {
    mach: (laudo) => {
        if (_.get(laudo, "apontamentos.colheitas.perd") || _.get(laudo, "apontamentos.colheitas.piso")) {
            return true;
        }

        return false;
    },
    parser: (laudo, valueFile) => {
        // console.log("parser laudo", laudo);
        let mapTipoPerda = {
            canaInteira: 1,
            canaFixa: 2,
            estilhaco: 3,
            toco: 4,
            tolete: 5,
            ponteiro: 6, //???
            pedaco: 7,
        };
        let perdas = _.get(laudo, "apontamentos.colheitas.perd");
        let pisoteio = _.get(laudo, "apontamentos.colheitas.piso");
        let arranquio = _.get(laudo, "apontamentos.colheitas.as");
        console.log("arranquio", arranquio);

        if (perdas) {
            for (let index = 0; index < perdas.length; index++) {
                const perda = perdas[index];

                let listItensPerda = [];

                Object.keys(mapTipoPerda).forEach((key) => {
                    //converte para quilos
                    listItensPerda.push({ tipo: mapTipoPerda[key], quantidade: perda[key] ? perda[key] / 1000 : "0" });
                });

                let objExport = {
                    indicador: "perd",
                    APONT_IDENT: laudo.sequencialIndex + "perd" + index,
                    LAUDOTCH: laudo.sequencialIndex,
                    LAUDOTCH_UID: laudo.uid,
                    DATA_AMOSTRA: laudo.data,
                    COD_FAZENDA: laudo.fazenda.codFazenda,
                    COD_TALHAO: perda.talhao.nome,
                    // ZONA: talhao., padrao 1?
                    COD_EQUIPAMENTO: perda.equipamento,
                    TURNO: perda.turno,
                    ITEMS_PERDA: listItensPerda,
                };
                // console.log("objExport", objExport);
                valueFile.push(objExport);
            }
        }
        if (pisoteio) {
            for (let index = 0; index < pisoteio.length; index++) {
                const piso = pisoteio[index];

                // console.log("pisoteio", piso);
                let totalRuasAvaliado = 0;
                let totalRuasComPisoteio = 0;
                if (piso.coletas) {
                    piso.coletas.forEach((coletas) => {
                        totalRuasAvaliado += parseFloat(coletas.ruasAvaliadas);
                        totalRuasComPisoteio += parseFloat(coletas.ruasComPisoteio);
                    });
                }

                let objExport = {
                    indicador: "piso",
                    APONT_IDENT: laudo.sequencialIndex + "piso" + index,
                    LAUDOTCH: laudo.sequencialIndex,
                    LAUDOTCH_UID: laudo.uid,
                    DATA_AMOSTRA: laudo.data,
                    COD_FAZENDA: laudo.fazenda.codFazenda,
                    COD_TALHAO: piso.talhao.nome,
                    // ZONA: talhao., padrao 1?
                    COD_EQUIPAMENTO: piso.trator.numeroFrotaTrator,
                    TURNO: piso.turno,

                    VALOR_TOTALANTES: "", //??
                    VALOR_TOTALDEPOIS: "", //??
                    METROS_AVALIADOS: totalRuasAvaliado, //em ruas
                    METRO_LINEARPISOTEIO: totalRuasComPisoteio, //em ruas
                };
                // console.log("objExport", objExport);
                valueFile.push(objExport);
            }
        }

        if (arranquio) {
            for (let index = 0; index < arranquio.length; index++) {
                const arr = arranquio[index];

                let totalAvaliados = 0;
                let totalRestante = 0;
                if (arr.coletas) {
                    arr.coletas.forEach((coletas) => {
                        totalAvaliados += parseFloat(coletas.avaliados);
                        totalRestante += parseFloat(coletas.avaliados) - parseFloat(coletas.arrancados);
                    });
                }

                let objExport = {
                    indicador: "as",
                    APONT_IDENT: laudo.sequencialIndex + "as" + index,
                    LAUDOTCH: laudo.sequencialIndex,
                    LAUDOTCH_UID: laudo.uid,
                    DATA_AMOSTRA: laudo.data,
                    COD_FAZENDA: laudo.fazenda.codFazenda,
                    COD_TALHAO: arr.talhao.nome,
                    // ZONA: talhao., padrao 1?
                    COD_EQUIPAMENTO: arr.trator.numeroFrotaTrator,
                    TURNO: arr.turno,

                    VALOR_TOTALANTES: totalAvaliados, //??
                    VALOR_TOTALDEPOIS: totalRestante, //??
                    METROS_AVALIADOS: "", //em ruas
                    METRO_LINEARPISOTEIO: "", //em ruas
                };
                // console.log("objExport", objExport);
                valueFile.push(objExport);
            }
        }
        // console.log("listExport", valueFile);
    },
};

let parsers = [parserPerdas, parserPadrao];

export function exportFile(laudos, props) {
    let valueFile = [];
    laudos.forEach((laudo) => {
        for (let index = 0; index < parsers.length; index++) {
            const parser = parsers[index];
            if (parser.mach(laudo)) {
                parser.parser(laudo, valueFile);
            }
        }
    });
    // console.log("valueFile", valueFile);

    gerarArquivo(JSON.stringify(valueFile), "Export.json");
}

const configExport = { nome: "(BETA) Exportar Perdas, Pisoteio e Arranquio - SBA-CS", exportFile: exportFile };
export default configExport;
const gerarArquivo = (jsonse, nome) => {
    let fileBlob = new Blob([jsonse], { type: "application/json" });
    if (window.cordova) {
        document.addEventListener("deviceready", function () {
            var storageLocation = "";
            console.log("window.cordova", window.cordova);
            storageLocation = window.cordova.file.dataDirectory;

            var folderPath = storageLocation;
            console.log("folderPath", folderPath);
            console.log("nome", nome);
            window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                    console.log("Access to the directory granted succesfully", dir);
                    dir.getFile(
                        nome,
                        {
                            create: true,
                        },
                        function (file) {
                            console.log("file", file);
                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.write(fileBlob);

                                    fileWriter.onwriteend = function () {
                                        var url = file.toURL();
                                        console.log("url", url);
                                        window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                            error: function error(err) {
                                                console.error(err);
                                                alert("Unable to download3");
                                            },
                                            success: function success() {
                                                console.log("success with opening the file");
                                            },
                                        });
                                    };

                                    fileWriter.onerror = function (err) {
                                        alert("Unable to download2");
                                        console.error(err);
                                    };
                                },
                                function (err) {
                                    // failed
                                    alert("Unable to download");
                                    console.error("err", err);
                                }
                            );
                        },
                        function (err) {
                            alert("Unable to download");
                            console.error(err);
                        }
                    );
                },
                function (err) {
                    alert("Unable to download");
                    console.error(err);
                }
            );
        });
    } else {
        var element = document.createElement("a");

        // let file = new Blob([texto], { type: "text/plain;charset=utf-8" })
        element.href = URL.createObjectURL(fileBlob);
        element.download = nome;
        element.click();
    }
};
